import { Injectable, signal } from '@angular/core';
import { IMatch } from '../../../../server/interfaces/match';
import { HttpService } from './http.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class MatchService {
  match = signal<IMatch | null>(null);
  matches = signal<IMatch[]>([]);

  loading = signal<boolean>(false);

  constructor(
    private http: HttpService,
    private notification: NotificationService
  ) {}

  async getMatchById(matchId: string): Promise<IMatch | null> {
    if (this.loading()) return null;

    this.loading.set(true);
    const res = await this.http.get<IMatch>(`/match/public/${matchId}`, null);
    this.loading.set(false);

    if (res.error) {
      this.notification.error(res.error);
      return null;
    }

    this.match.set(res.data);
    return res.data;
  }

  async getMatchesByMatchSessionId(matchSessionId: string) {
    if (this.loading()) return;

    this.loading.set(true);
    const res = await this.http.get<IMatch[]>(`/match/${matchSessionId}`, null);
    this.loading.set(false);

    if (res.error) {
      this.notification.error(res.error);
      return;
    }

    this.matches.set(res.data);
  }

  async getMatchesByTournamentId(tournamentId: string) {
    if (this.loading()) return;

    this.loading.set(true);
    const res = await this.http.get<IMatch[]>(
      `/tournament/${tournamentId}/matches`,
      null
    );
    this.loading.set(false);

    if (res.error) {
      this.notification.error(res.error);
      return;
    }

    this.matches.set(res.data);
  }
}
